export const WIRES_CONTAINER_TAG_NAME = 'wires-container';
export const JH_WIRES_CONTAINER_TAG_NAME = 'jh-wires-container';
